/**
 * Utility functions for sending custom properties to Microsoft Clarity
 * Clarity is configured through Google Tag Manager
 */

interface ClarityUserProperties {
  uid: string;
  full_name?: string;
  email?: string;
  phone_number?: string | null;
}

/**
 * Sends user properties to Microsoft Clarity via GTM dataLayer
 * This pushes data to the dataLayer which GTM can then forward to Clarity
 */
export const sendClarityUserProperties = (properties: ClarityUserProperties): void => {
  // Ensure dataLayer exists (from GTM)
  if (typeof window !== 'undefined' && window.dataLayer) {
    // Push custom properties to dataLayer
    // GTM can be configured to forward these to Clarity
    window.dataLayer.push({
      event: 'clarity_set_user_properties',
      clarity_user_properties: {
        uid: properties.uid,
        full_name: properties.full_name || '',
        email: properties.email || '',
        phone_number: properties.phone_number || '',
      },
    });
  }

  // Also try to set properties directly on Clarity if available
  // This is a fallback in case Clarity is loaded directly
  if (typeof window !== 'undefined' && (window as Window).clarity) {
    try {
      (window as Window).clarity?.('set', 'uid', properties.uid);
      if (properties.full_name) {
        (window as Window).clarity?.('set', 'full_name', properties.full_name);
      }
      if (properties.email) {
        (window as Window).clarity?.('set', 'email', properties.email);
      }
      if (properties.phone_number) {
        (window as Window).clarity?.('set', 'phone_number', properties.phone_number);
      }
    } catch (error) {
      console.warn('Failed to set Clarity properties directly:', error);
    }
  }
};
